"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = stopSpeakingActivity;
exports.STOP_SPEAKING_ACTIVITY = void 0;
var STOP_SPEAKING_ACTIVITY = 'WEB_CHAT/STOP_SPEAKING';
exports.STOP_SPEAKING_ACTIVITY = STOP_SPEAKING_ACTIVITY;

function stopSpeakingActivity() {
  return {
    type: STOP_SPEAKING_ACTIVITY
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3N0b3BTcGVha2luZ0FjdGl2aXR5LmpzIl0sIm5hbWVzIjpbIlNUT1BfU1BFQUtJTkdfQUNUSVZJVFkiLCJzdG9wU3BlYWtpbmdBY3Rpdml0eSIsInR5cGUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxzQkFBc0IsR0FBRyx3QkFBL0I7OztBQUVlLFNBQVNDLG9CQUFULEdBQWdDO0FBQzdDLFNBQU87QUFDTEMsSUFBQUEsSUFBSSxFQUFFRjtBQURELEdBQVA7QUFHRCIsInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFNUT1BfU1BFQUtJTkdfQUNUSVZJVFkgPSAnV0VCX0NIQVQvU1RPUF9TUEVBS0lORyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHN0b3BTcGVha2luZ0FjdGl2aXR5KCkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IFNUT1BfU1BFQUtJTkdfQUNUSVZJVFlcbiAgfTtcbn1cblxuZXhwb3J0IHsgU1RPUF9TUEVBS0lOR19BQ1RJVklUWSB9O1xuIl19